// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2KeeS","requiredAsterisk":"Info_requiredAsterisk__1-skj"};